<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <!-- <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div> -->
      <div class="text-right leading-tight hidden sm:block">
        <p class="font-semibold">{{ name }}</p>
        <small>Available</small>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import AuthService from "../../../../auth/msal2-authService";

export default {
  data() {
    return {
      name: "",
    };
  },

  async created() {
    // this.name = this.$store.state.AppActiveUser;
    this.name = localStorage.getItem("msal.pkce.access.name");
    // let authService = new AuthService();
    // await authService.getPhoto();
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    async logout() {
      // this.$router.push("/pages/login").catch(() => {});
      // this.$msal.signOut();
      let authService = new AuthService();
      await authService.logout();
    },
  },
};
</script>
